import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'drop-down',
  template: `
  <select class="primary-dropdown" 
  (change)='onOptionsSelected($event.target.value)'>
      <option value="{{data}}"  *ngFor="let data of lists">{{data}}</option>
  </select>
`,
  styleUrls: ['./drop-down.component.css']
})
export class DropDownComponent implements OnInit {
  @Input() lists;
  @Output() selectedData: any = new EventEmitter<any>();


  constructor() { }

  ngOnInit() {

  }

  onOptionsSelected(value) {
    this.selectedData.emit(value)
  }
}
